import {PROJECT_STATUS} from '../../../../constants';

type ProgramStage = {id: string; name: string | null};

// Opportunity and Halted are legacy stages for programs: a program already in one keeps it, but no program can be
// moved into one.
const SELECTABLE_PROGRAM_STAGES: string[] = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.RUNNING, PROJECT_STATUS.DONE];

/**
 * The stages a program can be moved to, in the order given: Planning, Running and Done, plus the program's current
 * stage so a program in a legacy stage still shows it.
 */
export const getProgramStageOptions = <T extends ProgramStage>(stages: T[], currentStageId: string | undefined): T[] =>
	stages.filter(
		stage => SELECTABLE_PROGRAM_STAGES.some(selectable => selectable === stage.name) || stage.id === currentStageId
	);
